angular.module('tf.directives')

    .directive('controlsSection', ['$rootScope','$timeout','$compile', function ($rootScope, $timeout, $compile) {
        return{
            restrict:'E',
            scope:{
                template : "="
            },
            link: function(scope,element){

                function sumWidth(row){
                    var sum = 0;
                    for (var i = 0; i < row.length; i++) {
                        var control = row[i];
                        sum += (control.displayWidth && parseInt(control.displayWidth)) || 100;
                    }
                    return sum;
                }

                function buildControlTable(){
                    var controlTable = [[]];
                    if( scope.template && scope.template.controls){
                        for (var i = 0; i < scope.template.controls.length; i++) {
                            var control = scope.template.controls[i];
                            var width = (control.displayWidth && parseInt(control.displayWidth)) || 100;
                            var row = controlTable[controlTable.length-1];
                            if (sumWidth(row) + width > 100){
                                controlTable.push([control]);
                            } else {
                                row.push(control);
                            }
                        }
                    }
                    return controlTable;
                }

                function buildGrid(controlTable){
                    $(element).empty();
                    for (var i = 0; i < controlTable.length; i++) {
                        var row = controlTable[i];
                        var rowElement = angular.element('<div class="control-row"></div>');
                        element.append(rowElement);
                        for (var j = 0; j < row.length; j++) {
                            var controlScope = scope.$new();
                            var control = row[j];
                            controlScope.control = control;
                            var controlElement = angular.element('<template-control control="control"></template-control>');
                            rowElement.append(controlElement);
                            $compile(controlElement)(controlScope);
                        }
                    }
                }

                function initControlGrid(){
                    var controlTable = buildControlTable();
                    buildGrid(controlTable);
                }

                scope.$watch("template",function() {
                    initControlGrid();
                });

                initControlGrid();
            }
        };
    }])
;